import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";
import { Callout } from "@proda-ai/ui-kit";

type TToast = {
    id: string;
    kind: "toast";
    title: string;
    message?: string;
    severity: "success" | "warning" | "danger" | "info";
};

export type ViewToastsParams = {
    useState: () => {
        toasts: TToast[];
    };
    useCases: () => {
        removeNotification: (id: string) => void;
    };
};

export type ViewToastsProps = Omit<BoxProps, "children">;

export const testId = "ViewToasts";

export const createViewToasts = ({ useState, useCases }: ViewToastsParams) => {
    const ViewToasts = (props: ViewToastsProps) => {
        const { sx, className, ...otherProps } = props;

        const { toasts } = useState();
        const { removeNotification } = useCases();

        return (
            <Box
                data-testid={testId}
                className={clsx([testId, className])}
                sx={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "10px",
                    ...sx,
                }}
                {...otherProps}
            >
                {toasts.map(toast => (
                    <Callout
                        key={toast.id}
                        type={toast.severity}
                        title={toast.title}
                        message={toast.message}
                        withCloseButton={true}
                        onClose={() => removeNotification(toast.id)}
                    />
                ))}
            </Box>
        );
    };

    return ViewToasts;
};
